import { useInfiniteQuery } from "@tanstack/react-query";
import { emptyPage, Page, SimpleUserSentenceStatistics } from "@/model";
import statisticsRepository from "@/repository/statisticsRepository";


const getData = async (
    agentId: number,
    startDate: string,
    endDate: string,
    sortKey: string,
    sortOrder: string,
    page: number,
    size: number
) => {
    const res = await statisticsRepository.getUserSentencePage(
        agentId, startDate, endDate, sortKey, sortOrder, page, size
    );

    const sentencePage = res.data?.data;
    if (!sentencePage?.content) {
        return emptyPage<SimpleUserSentenceStatistics>();
    }
    const newContent: SimpleUserSentenceStatistics[] = sentencePage.content.map(sentence => {
        const simpleStat: SimpleUserSentenceStatistics = {
            query: sentence.ner.query,
            created_at: sentence.created_at!.slice(0, 19),
        };

        if (sentence.answers?.length > 0) {
            const firstIntent =  sentence.answers[0].intent;

            simpleStat.intent_id = firstIntent.intent_id;
            simpleStat.intent_name = firstIntent.intent_name;
            simpleStat.skill_id = firstIntent.skill_id;
            simpleStat.skill_name = firstIntent.skill_name;
            simpleStat.score = firstIntent.score;
        }

        return simpleStat;
    });

    return {
        ...sentencePage,
        content: newContent,
    };
};

export const usePaginatedSimpleUserSentences = (
    agentId: number,
    startDate?: string,
    endDate?: string,
    sortKey?: string,
    sortOrder?: string,
) => {
    return useInfiniteQuery<Page<SimpleUserSentenceStatistics>>({
        enabled: !!startDate && !!endDate && !!sortKey && !!sortOrder,
        queryKey: [
            "statistics", "sentences-page",
            "agent", agentId,
            "start", startDate,
            "end", endDate,
            "sortKey", sortKey,
            "sortOrder", sortOrder,
        ],
        queryFn: ({ pageParam = { page: 0, size: 50 } as any }) => {
            return getData(agentId, startDate!, endDate!, sortKey!, sortOrder!, pageParam.page, pageParam.size);
        },
        initialPageParam: startDate,
        getNextPageParam: (lastPage) => {
            if (!lastPage?.has_next) {
                return undefined;
            }

            return {
                page: lastPage.page + 1,
                size: lastPage.size,
            };
        }
    });
};
